// Хост тостов.
//
// Тост подтверждает уже случившееся действие и, если можно, даёт отменить.
// ОШИБКИ ТОСТОМ НЕ ПОКАЗЫВАЮТСЯ: тост уезжает, а ошибку надо прочитать
// и что-то с ней сделать. Для ошибок есть ErrorState рядом с данными.
import { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";

type Toast = {
  id: number;
  text: string;
  undo?: () => void;
};

type ToastValue = {
  /** Показать подтверждение. `undo` — если действие обратимо. */
  notify: (text: string, undo?: () => void) => void;
};

const ToastContext = createContext<ToastValue | null>(null);

const LIFETIME_MS = 6000;

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const nextId = useRef(1);

  const dismiss = useCallback((id: number) => {
    setToasts((current) => current.filter((t) => t.id !== id));
  }, []);

  const notify = useCallback(
    (text: string, undo?: () => void) => {
      const id = nextId.current++;
      setToasts((current) => [...current, { id, text, undo }]);
      window.setTimeout(() => dismiss(id), LIFETIME_MS);
    },
    [dismiss],
  );

  const value = useMemo<ToastValue>(() => ({ notify }), [notify]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      {/* aria-live="polite": скринридер дочитает текущую фразу и только потом
          объявит тост. assertive перебивал бы человека на полуслове. */}
      <div className="toast-region" role="status" aria-live="polite">
        {toasts.map((toast) => (
          <div className="toast" key={toast.id}>
            <span className="toast__body">{toast.text}</span>
            {toast.undo && (
              <button
                type="button"
                className="toast__act"
                onClick={() => {
                  toast.undo?.();
                  dismiss(toast.id);
                }}
              >
                Отменить
              </button>
            )}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast(): ToastValue {
  const value = useContext(ToastContext);
  if (!value) {
    throw new Error("useToast вызван вне ToastProvider");
  }
  return value;
}
